/**
 * Checks if the application is running in an e2e testing environment
 * based on the current domain.
 *
 * Counterpart of `isE2eSession` in @verifyiq/frontend-utils, which the Vite
 * frontends use — this legacy CRA app cannot import libs/ until its Vite
 * migration (react-scripts cannot compile them). Keep the two in sync; this
 * copy additionally keys off REACT_APP_NODE_TEST_ENV and an explicit domain
 * allowlist because it also gates the reCAPTCHA bypass in sign-in-form.
 *
 * @returns true if the current domain is the e2e testing domain
 */
export const isE2EEnvironment = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }

  const e2eDomains = [
    'e2e.verifyiq.boost-frontend.app',
    'e2e.verifyiq-dev.boost-frontend.app',
    'staging-e2e.verifyiq.boost-frontend.app',
    'e2e.verifyiq-mercury-dev.boost-frontend.app',
    'e2e.portal.verifyiq.xyz',
  ];
  return (
    e2eDomains.includes(window.location.hostname) ||
    process.env.REACT_APP_NODE_TEST_ENV === 'true'
  );
};
